import { IndicationItem } from 'features/indicationTriage/api/indicationTriageApi'
import { useIndicationData } from 'features/indicationTriage/IndicationContext'
import { IndicationDetailCardProps } from 'features/indicationTriage/useIndicationDetailCards'
import { useRolodexEntries } from 'features/rolodex'
import React, { FC, useMemo } from 'react'
import styled from 'styled-components'
import { RolodexEntryType } from 'types'

const PHOTOGRAMMETRY_TYPE = RolodexEntryType.INDICATION_PHOTOGRAMMETRY

const NiraIframe = styled.iframe`
  height: 24vh;
  margin: auto;
  display: block;
  border: 0;
`

export const Title = () => 'Photogrammetry Model'
export const Width = '24rem'
export const useIsEnabled = (indicationItem?: IndicationItem): boolean => {
  const { entries: photogrammetryEntry } = useRolodexEntries(
    indicationItem
      ? {
          type: PHOTOGRAMMETRY_TYPE,
          tags: {
            indication: indicationItem.id,
          },
          limit: 1,
        }
      : undefined
  )
  return photogrammetryEntry.length > 0
}
export const CardView: FC<IndicationDetailCardProps> = () => {
  const { indication: indicationItem } = useIndicationData()
  const { entries: photogrammetryEntry } = useRolodexEntries(
    useMemo(
      () =>
        indicationItem
          ? [
              {
                type: PHOTOGRAMMETRY_TYPE,
                tags: {
                  indication: indicationItem.id,
                },
                limit: 1,
              },
            ]
          : [],
      [indicationItem]
    )
  )
  return (
    <NiraIframe
      width='100%'
      height='100%'
      loading='lazy'
      style={{ background: 'black' }}
      allowFullScreen
      src={photogrammetryEntry[0]?.data.url?.toString() ?? ''}></NiraIframe>
  )
}
